const plumberService = {
  title: "Plumber",
  icon: "🚰",
  shortDescription: "Tap, leakage, fitting, drainage, bathroom and kitchen plumbing support.",
  longDescription:
    "Book verified plumbing help for repairs, installations, replacements, leakage resolution, and home fixture support. Transparent pricing starts here while final slotting and worker assignment happen in checkout and backend orchestration.",
  consultationNote:
    "Inspection-based tasks may require on-site assessment before final material or labour estimate.",
  responsePromise:
    "Platform attempts fast assignment, with backend-led reassignment if needed.",
  warrantyPolicy:
    "Revisit or support eligibility depends on final job type and completion conditions.",
  subServices: [
    {
      id: "plumber-tap-repair",
      title: "Tap Repair",
      icon: "🚿",
      group: "Taps",
      description: "Fix common tap issues such as dripping, loose fitting, flow reduction, or minor leak repair.",
      basePrice: 149,
      priceType: "fixed",
      duration: "30-45 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "plumber-tap-installation",
      title: "Tap Installation",
      icon: "🧰",
      group: "Taps",
      description: "Install a new tap provided by customer or sourced separately through materials flow.",
      basePrice: 199,
      priceType: "fixed",
      duration: "30-60 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "plumber-tap-replacement",
      title: "Tap Replacement",
      icon: "🔁",
      group: "Taps",
      description: "Remove old tap and replace with a new unit with fitting and testing.",
      basePrice: 249,
      priceType: "fixed",
      duration: "45-75 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "plumber-shower-installation",
      title: "Shower Installation",
      icon: "🚿",
      group: "Bathroom",
      description: "Install or replace shower set, hand shower, or wall shower attachment.",
      basePrice: 249,
      priceType: "fixed",
      duration: "45-60 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "plumber-basin-pipe-leak",
      title: "Basin Pipe Leak Repair",
      icon: "💧",
      group: "Leakage",
      description: "Resolve minor basin or wash-area pipe leakage and fitting issues.",
      basePrice: 179,
      priceType: "fixed",
      duration: "30-45 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "plumber-drain-blockage",
      title: "Drain Blockage Clearing",
      icon: "🛠️",
      group: "Drainage",
      description: "Clear drain blockage in bathroom, wash area, or kitchen waste lines for normal flow.",
      basePrice: 249,
      priceType: "starts_at",
      duration: "45-75 mins",
      warranty: "3 days",
      unit: "job",
    },
    {
      id: "plumber-sink-installation",
      title: "Sink / Basin Installation",
      icon: "🧱",
      group: "Bathroom",
      description: "Install wash basin or sink with basic plumbing connection alignment.",
      basePrice: 399,
      priceType: "starts_at",
      duration: "60-120 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "plumber-flush-tank-repair",
      title: "Flush Tank Repair",
      icon: "🚽",
      group: "Bathroom",
      description: "Fix flush tank leakage, filling issue, handle problem, or weak flushing performance.",
      basePrice: 249,
      priceType: "fixed",
      duration: "45-60 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "plumber-water-motor-check",
      title: "Water Motor Check",
      icon: "⚙️",
      group: "Motor & Supply",
      description: "Basic inspection for water motor connection and supply-related plumbing flow issues.",
      basePrice: 199,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
    {
      id: "plumber-pipeline-inspection",
      title: "Pipeline Inspection",
      icon: "🔍",
      group: "Leakage",
      description: "Inspect hidden or visible plumbing lines for leak source, breakage, or routing issues.",
      basePrice: 249,
      priceType: "inspection",
      duration: "45-60 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
  ],
};

export default plumberService;